module.exports = __webpack_public_path__ + "static/media/piedmonthealthcare.e32e73a9.png";